<script lang="ts" setup>
interface Props {
  error: Error
  errorUpdateCount: number
}

defineProps<Props>()
defineEmits(['reset', 'refetch'])
</script>

<template>
  <div role="alert" class="w-96 max-w-full p-3">
    <p class="text-xl">
      {{ $t('unexpected-error') }}
    </p>
    <p class="my-3 flex flex-col">
      {{ $t('auction-list.fetch-failed') }}
      <span class="text-xs">({{ error }})</span>
    </p>

    <div class="flex gap-3">
      <elements-button size="tiny" outline @click="$emit('reset')">
        {{ $t('search-form.reset-filters') }}
      </elements-button>

      <elements-button
        v-if="errorUpdateCount === 1"
        size="tiny"
        @click="$emit('refetch')"
      >
        {{ $t('auction-list.refetch') }}
      </elements-button>
    </div>
  </div>
</template>
